module.exports = __webpack_public_path__ + "img/13.9b8937f7.jpg";